/**
 * HausWax Preview v3
 * 1. CSS inyectado: tracks con preview = rojo + subrayado
 * 2. Click en track del tracklist → navega galeria al video
 * 3. Pausa YouTube al navegar slides (cualquier click en galeria fuera del iframe)
 */
(function () {

  // ── 1. CSS: links de tracklist en rojo ───────────────────────────────────
  var style = document.createElement('style');
  style.textContent =
    '.product__description a[href*="youtu.be"],' +
    '.product__description a[href*="youtube.com/watch"],' +
    '.rte a[href*="youtu.be"],' +
    '.rte a[href*="youtube.com/watch"],' +
    '[class*="product-description"] a[href*="youtu.be"],' +
    '[class*="product-description"] a[href*="youtube.com/watch"] {' +
    '  color: #c0392b !important;' +
    '  text-decoration: underline !important;' +
    '  cursor: pointer;' +
    '}';
  document.head.appendChild(style);

  // ── 2. Pausa todos los iframes de YouTube ────────────────────────────────
  function pauseAllYouTube() {
    document.querySelectorAll('iframe[src*="youtube.com/embed"]').forEach(function (frame) {
      // postMessage (requiere enablejsapi=1)
      try {
        frame.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
          'https://www.youtube.com'
        );
      } catch (e) {}
      // Fallback: quitar autoplay del src para detener reproduccion
      if (frame.src && frame.src.indexOf('autoplay=1') !== -1) {
        var newSrc = frame.src.replace('autoplay=1', 'autoplay=0');
        frame.setAttribute('src', newSrc);
      }
    });
  }

  // ── 3. Extrae YouTube video ID ────────────────────────────────────────────
  function extractYtId(url) {
    var m = url.match(/youtu\.be\/([A-Za-z0-9_-]{11})/);
    if (m) return m[1];
    m = url.match(/[?&]v=([A-Za-z0-9_-]{11})/);
    return m ? m[1] : null;
  }

  // ── 4. Click handler ─────────────────────────────────────────────────────
  function handleClick(e) {
    var target = e.target;

    // Cualquier click DENTRO de la galeria que NO sea en el iframe ni en un link
    // → pausar YouTube (cubre flechas, bullets, thumbnails, etc.)
    var inGallery = target.closest('media-gallery');
    if (inGallery && !target.closest('iframe') && !target.closest('a[href*="youtu"]')) {
      pauseAllYouTube();
      return; // dejar que la navegacion normal continue
    }

    // Click en link de tracklist → navegar galeria al video
    var link = target.closest('a[href*="youtu.be/"], a[href*="youtube.com/watch"]');
    if (!link) return;

    // Solo dentro de la descripcion del producto
    var desc = link.closest(
      '.product__description, [class*="product-description"], .rte, [class*="description"]'
    );
    if (!desc) return;

    var ytId = extractYtId(link.getAttribute('href') || '');
    if (!ytId) return;

    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var allMedia = Array.from(gallery.querySelectorAll('[data-media-id]'));
    var targetIndex = allMedia.findIndex(function (el) {
      return el.getAttribute('data-yt-id') === ytId;
    });

    if (targetIndex === -1) return; // No en galeria → abrir YouTube normalmente

    e.preventDefault();
    pauseAllYouTube();

    var slideshow = gallery.slideshow;
    if (slideshow && typeof slideshow.select === 'function') {
      slideshow.select(targetIndex, undefined, { animate: true });
    } else {
      // Fallback: buscar bullets por indice
      var bullets = gallery.querySelectorAll('[ref="bullet"], button[data-index], .slideshow__bullet');
      if (bullets[targetIndex]) bullets[targetIndex].click();
    }

    gallery.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  // ── 5. Teclado en galeria ────────────────────────────────────────────────
  function handleKeydown(e) {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      var active = document.activeElement;
      if (active && active.closest('media-gallery, slideshow-component')) {
        pauseAllYouTube();
      }
    }
  }

  // ── Init ─────────────────────────────────────────────────────────────────
  function init() {
    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeydown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
